import Vue from 'vue'

import ProductList from './components/catalog/ProductList'
import BuyButton from "./components/catalog/BuyButton";
import AddToWaitListButton from "./components/catalog/AddToWaitListButton";

import ProductSlider from "./components/catalog/ProductSlider";
import ProductMultiSlider from "./components/catalog/ProductMultiSlider";

import TopCatalog from "./components/catalog/TopCatalog";
import SearchString from "./components/catalog/SearchString";
import SearchStringMobile from "./components/catalog/SearchStringMobile";

import Basket from "./components/customer/Basket";
import BasketFloat from "./components/customer/BasketFloat";
import BasketButton from "./components/customer/BasketButton";
import BasketPrint from "./components/customer/BasketPrint";

import MenuButton from "./components/customer/MenuButton";
import MenuFloat from "./components/customer/MenuFloat";

import Checkout from "./components/customer/Checkout";

import LoginForm from "./components/customer/LoginForm";
import LoginFormFloat from "./components/customer/LoginFormFloat";
import LoginFormButton from "./components/customer/LoginFormButton";

import RegistrationForm from "./components/customer/RegistrationForm";
import RememberPasswordForm from "./components/customer/RememberPasswordForm";
import WhereToBuy from "./components/customer/WhereToBuy";

import ContactMap from "./components/customer/ContactMap";

import QuickOrder from "./components/catalog/QuickOrder";

import ContactForm from "./components/customer/ContactForm";

import OfficeMap from "./components/core/OfficeMap.vue";

import FaqForm from "./components/core/FaqForm";
import FaqLink from "@/components/core/FaqLink.vue";
import BannerSlider from "@/components/core/BannerSlider.vue";

import PromoGoldenAction from "@/components/core/PromoGoldenAction.vue";


import underscore from 'vue-underscore'
import VueResource from 'vue-resource'
import VModal from 'vue-js-modal'
import YmapPlugin from 'vue-yandex-maps'
import VueWaypoint from "vue-waypoint/src";

import VueMask from 'v-mask'


Vue.use(YmapPlugin, {
    apiKey: 'efa45a74-34c6-4532-aa40-25baa3a1babd',
    lang: 'ru_RU',
    coordorder: 'latlong',
    version: '2.1'
})

Vue.use(VModal, { dialog: true, dynamic: true})
Vue.use(underscore)
Vue.use(VueResource)
Vue.use(VueWaypoint)
Vue.use(VueMask)

Vue.config.productionTip = false
Vue.prototype.$log = window.console.log
Vue.prototype.$scrollToTop = () => window.scrollTo(0,0)


import './filters'

import './assets/css/style.less'

import './assets/libs/NBrain/NBrain.less'
import './assets/libs/boostrap_slider/boostrap_slider.min.css'
// import './assets/libs/fancybox/fancybox.min.css'
import './assets/libs/select2/select2.min.css'
import './assets/libs/slick/slick.css'
import './assets/libs/swiper/swiper.min.css'

import './assets/css/bootstrap-custom.scss'

import { store } from './store'

Vue.directive('select2', {
    twoWay: true,
    bind: function (el) {
        window.$(el).select2().on("select2:select", (e) => {
            el.dispatchEvent(new Event('change', { target: e.target }));
        });
        window.$(el).select2().on("select2:unselect", (e) => {
            el.dispatchEvent(new Event('change', { target: e.target }));
        });
        window.$(el).select2().on("select2:clear", (e) => {
            el.dispatchEvent(new Event('change', { target: e.target }));
        });
    },
});

Vue.http.interceptors.push( (request, next) => {
    // continue to next interceptor
    next( (response) => {
        if (response.status == 401) {
            if(response.url != '/login'){
                window.location.href='/customer/login-form'
            }
            window.console.log(response);
            return
        }
        if (response.status == 403) {
            window.console.log('403 code');
        }
        if (response.status == 500 || response.status == 502 || response.status == 504 ) {
            if(response.body && response.body.message){
                Vue.prototype.$modal.show('dialog', {
                    title: 'Ошибка',
                    text: response.body.message,
                    buttons: [
                        {
                            title: 'Закрыть'
                        }
                    ]
                })
//                alert(response.body.message);
            }
            window.console.log(response);
            // eventBus.$emit('global.wrong.response', response.body.message);
        }
    })
})


new Vue({
    components: {
        ProductList,
        BuyButton,

        AddToWaitListButton,

        ProductSlider,
        ProductMultiSlider,

        TopCatalog,

        BasketPrint,
        Basket,
        Checkout,

        ContactMap,

        BasketFloat,
        LoginFormFloat,

        SearchString,
        SearchStringMobile,
        BasketButton,
        LoginFormButton,

        MenuButton,
        MenuFloat,

        LoginForm,
        RegistrationForm,
        RememberPasswordForm,

        WhereToBuy,
        QuickOrder,

        ContactForm,
        OfficeMap,
        FaqForm,
        FaqLink,

        BannerSlider,

        PromoGoldenAction
    },
    store
}).$mount('#app')